export enum LeftPanelView {
  OUTLINE = 'outline',
  ADD_TOP_LEVEL = 'add_top_level',
  ADD_CONTENT = 'add_content',
  NOVO_AI = 'novo_ai',
}

export enum CommunityCompletionRowType {
  LECTURE = 'lecture',
  LECTURE_VIDEO = 'lectureVideo',
  SUBMISSION = 'submission',
  QUIZ = 'quiz',
  SURVEY = 'survey',
  EVALUATION = 'evaluation',
}
